<template>
    <div class="bottom-container">
        <div class="composeBtn-container">
            <div class="left-btn">
                <div class="composeBtn" :style="'margin-right:' + compose.fz">
                    <p>朗读速度</p>
                    <ul>
                        <li v-for="(list,index) in compose.speedList" v-bind:key="index" @click="compose.speedNowIndex = index;editSpeed(list.speed)" :class="compose.speedNowIndex == index ? 'on' : ''">{{list.name}}</li>
                    </ul>
                </div>
                <div class="composeBtn" :style="'margin-right:' + compose.fz">
                    <p>插入停顿</p>
                    <ul>
                        <!-- <li v-for="(list,index) in compose.stopList" v-bind:key="index" @click="compose.stopNowIndex = index;setStop(list.stop)" :class="compose.stopNowIndex == index ? 'on' : ''">{{list.name}}</li> -->
                        <li v-for="(list,index) in compose.stopList" v-bind:key="index" @click="compose.stopNowIndex = index;setStop(list.stop)">{{list.name}}</li>
                    </ul>
                </div>
                <div class="composeBtn" :style="'margin-right:' + compose.fz">
                    <p><span>数值处理</span><img src="../assets/previewQuestionIcon.png"></p>
                    <div class="tip-container">
                        Eg：2008 【数值】 二千零八 【数字】 二零零八
                    </div>
                    <ul>
                        <!-- <li v-for="(list,index) in compose.numberList" v-bind:key="index" @click="compose.numberNowIndex = index;setNum(list.num)" :class="compose.numberNowIndex == index ? 'on' : ''">{{list.name}}</li> -->
                        <li v-for="(list,index) in compose.numberList" v-bind:key="index" @click="compose.numberNowIndex = index;setNum(list.num)">{{list.name}}</li>
                    </ul>
                </div>
                <div class="composeBtn on">
                    <p>多音字</p>
                    <ul>
                        <li v-for="(list,index) in compose.wordList" v-bind:key="index" @click="compose.wordNowIndex = index;setWord()">{{list.name}}</li>
                    </ul>
                </div>
            </div>
            <div class="right-btn">
                <!-- <p>
                    <img src="../assets/previewAlertIcon.png">
                    <span>请在文字前添加标注</span>
                </p> -->
                <button @click="composeSubmit" class="el-button compose"><i class="composeIcon"></i><span>合成</span></button>
                <!-- <img :style="'margin-left:'+ compose.fl +';margin-right:' + compose.fr" v-if="compose.canPlay==false&&compose.isPlay==false" @click="playAudio" src="../../assets/playBtn.png">
                <img :style="'margin-left:'+ compose.fl +';margin-right:' + compose.fr" v-if="compose.canPlay" src="../../assets/canPlayBtn.png">
                <img :style="'margin-left:'+ compose.fl +';margin-right:' + compose.fr" v-if="compose.canPlay==false&&compose.isPlay==true" @click="playAudio" src="../../assets/pauseBtn.png">
                <div class="voiceTime">
                    <div class="slider-container">
                        <div @mousemove="checkMove" @mousedown="clickMouse" class="slider">
                            <p ref="slider" 
                                @mousedown.stop="mouseClick=true;"
                                @mouseup="mouseClick=false"
                                @mouseleave="mouseClick=false"
                                class="slider-pointer">
                            </p>
                            <div :style="'width:'+percent+'%'" class="slider-fill"></div>
                        </div>
                    </div>
                    <span>{{compose.startTime}}</span>
                    <span>{{compose.endTime}}</span>
                </div> -->
            </div>
        </div>
        <div :class="isShow ? 'insert-container' : 'insert-container hide'">
            <div class="insert">
                <div class="header-container">
                    <p>多音字</p>
                    <img @click="isShow=false;insertWord=''" src="../assets/previewCloseIcon.png">
                </div>
                <div class="content-container">
                    <input type="text" v-model="insertWord">
                    <div class="select">
                        <input @click="isSelect=!isSelect" type="text" v-model="selectValue" readonly>
                        <span @click="isSelect=!isSelect"></span>
                        <ul v-show="isSelect" class="option-container">
                            <li @click="selectIndex=index;selectValue=item.name;isSelect=false" :class="index==selectIndex ? 'selected' : ''" v-for="(item,index) in selectOption" v-bind:key="index">{{item.name}}</li>
                        </ul>
                    </div>
                </div>
                <div class="footer-container">
                    <button @click="insert(insertWord,1)" class="el-button confirm">确定</button>
                </div>
            </div>
        </div>
        <audio id="audio" preload="true"></audio>
    </div>
</template>
<script>
// import moment from "moment";

export default {
    props: ['src'],
    watch: {
        src(to) {
            this.loadAudio(to);
        }
    },
    data() {
        return {
            insertWord: '',
            isShow: false,
            mouseClick: false,
            isSelect: false,
            myAudio: null,
            time: null,
            percent: 0,
            l: 0,
            width: 0,
            duration: 0,
            selectValue: '第一声',
            selectIndex: 0,
            selectOption: [
                {
                    name: '第一声'
                },
                {
                    name: '第二声'
                },
                {
                    name: '第三声'
                },
                {
                    name: '第四声'
                }
            ],
            compose: {
                speedList: [
                {name: '0.5X',speed: '-500'},
                {name: '0.8X',speed: '-200'},
                {name: '1.0X',speed: '0'},
                {name: '1.2X',speed: '+200'},
                {name: '1.5X',speed: '+500'}
                ],
                speedNowIndex: 2,
                stopList: [
                    {name: '0.1秒',stop: '[p100]'},
                    {name: '0.2秒',stop: '[p200]'},
                    {name: '0.4秒',stop: '[p400]'},
                    {name: '0.6秒',stop: '[p600]'},
                    {name: '1秒',stop: '[p1000]'},
                ],
                stopNowIndex: 99,
                numberList: [
                    {name: '数值',num: '[n2]'},
                    {name: '数字',num: '[n1]'}
                ],
                numberNowIndex: 99,
                wordList: [
                    {name: '插入'}
                ],
                wordNowIndex: 99,
                audioVol: 0,
                speed: 0,
                startTime: '00:00:00',
                endTime: '00:00:00',
                isPlay: false,
                endNum: 0,
                currentTime1: 0,
                canPlay: true,
                time: null,
                fz: 0,
                fl: 0,
                fr: 0
            }
        }
    },
    methods: {
        loadAudio(data) {
            var that = this;
            var left = document.getElementsByClassName("slider-container")[0];
            var l = left.offsetLeft;
            var width = l + 180;
            this.l = l;
            this.width = width;
            if(data != ''){
                this.myAudio.src = data;
                this.myAudio.load();
                this.myAudio.addEventListener("canplay",function(){
                    var audioTime = parseInt(that.myAudio.duration);
                    that.duration = audioTime
                    that.compose.startTime = '00:00:00';
                    that.compose.endTime = that.formatDuration(Number(audioTime)*1000,'hh:mm:ss');
                    that.compose.canPlay = false;
                })

                this.myAudio.addEventListener("ended",function(){
                    clearInterval(that.time);
                    that.time = null;
                    that.myAudio.pause();
                    that.myAudio.load();
                    that.changeTime(0)
                })
            }else{
                that.compose.canPlay = true;
            }
        },
        clickMouse(e) {
            var left = document.getElementsByClassName("slider-container")[0];
            var l = left.offsetLeft;
            var width = l + 180;
            var left1 = e.clientX - l - 8;
            var left2 = e.clientX - l;
            if(left2<=0){
                left1 = 0;
            }else if(left2>=width){
                left2 = width;
            }
            var percent = left2/180;
            if(this.time!=null){
                clearInterval(this.time);
                this.time = null;
            }
            this.compose.isPlay = false;
            this.myAudio.currentTime = percent * this.duration;
            this.percent = percent*100;
            var slider = this.$refs.slider;
            slider.style.left = left1 + 'px';
        },
        checkMove(e) {
            if(this.mouseClick){
                var left = document.getElementsByClassName("slider-container")[0];
                var l = left.offsetLeft;
                var width = l + 180;
                if(e.clientX>=l&&e.clientX<=width){
                    var left1 = e.clientX - l - 8;
                    var left2 = e.clientX - l;
                    if(left2<=0){
                        left1 = 0;
                    }else if(left2>=width){
                        left2 = width;
                    }
                    var percent = left2/180;
                    if(this.time!=null){
                        clearInterval(this.time);
                        this.time = null;
                    }
                    this.compose.isPlay = false;
                    this.myAudio.currentTime = percent * this.duration;
                    this.percent = percent*100;
                    var slider = this.$refs.slider;
                    slider.style.left = left1 + 'px';
                }
            }
        },
        insert(value,key) {
            var article1 = document.getElementById('article');
            var articleContent = '';
            var startPos = '';
            var endPos ='';
            var length = '';
            if(key==1){
                if(value==''||value==null||value==undefined){
                    alert('多音字不能为空')
                    return false
                }
                this.isShow=false;        
                startPos = article1.selectionStart;
                endPos = article1.selectionEnd;
                var selectIndex = this.selectIndex+1;
                articleContent = article1.value.substring(0, startPos) + '[=' + value + selectIndex + ']' + article1.value.substring(endPos, article1.value.length);
                article1.focus();
                length = value.length+4;
                article1.selectionStart = startPos + length;
                article1.selectionEnd = startPos + length;
                length = startPos + length;
                this.insertWord = '';
            }else{
                startPos = article1.selectionStart;
                endPos = article1.selectionEnd;
                articleContent = article1.value.substring(0, startPos) + value + article1.value.substring(endPos, article1.value.length);
                article1.focus();
                article1.selectionStart = startPos + value.length;
                article1.selectionEnd = startPos + value.length;
                length = startPos + value.length;
            }
            this.$emit('setContent',{
                value: articleContent,
                startPos: length,
                endPos: length
            })
        },
        playAudio() {
            // var that = this;

            // that.compose.isPlay = !that.compose.isPlay

            // if(that.time!=null){
            //     clearInterval(that.time);
            //     that.time = null;
            // }
            
            // if($('#audio').attr('src') != '' && $('#audio').attr('src') != null && $('#audio').attr('src') != undefined){
            //     if(that.compose.isPlay){

            //         if(that.time!=null){
            //             clearInterval(that.time);
            //             that.time = null;
            //         }

            //         $('#audio')[0].play();

            //         that.time = setInterval(function(){
            //             that.currentTime();
            //         },500)

            //     }else{

            //         $('#audio')[0].pause();
            //         if(that.time!=null){
            //             clearInterval(that.time);
            //             that.time = null;
            //         }

            //     }
            // }else{
            //     that.changeTime(0)
            // }
        },
        editSpeed(speed) {
            this.compose.speed = speed;
        },
        composeSubmit() {
            // console.log(123)
            this.$emit('compose',{
                speed: this.compose.speed
            });
        },
        setStop(stop) {
            this.insert(stop);
        },
        setWord() {
            this.isShow = !this.isShow;
        },
        setNum(num) {
            this.insert(num);
        },
        formatTooltip(val1) {
            return this.formatDuration(val1 * 1000,'hh:mm:ss');
        },
        formatDuration(val, formatStr) {
            this.deVal = val;
            this.deForm = formatStr;
            // const prefix = function (val) {
            //     if (val < 10) {
            //         return "0" + val;
            //     } else {
            //         return val;
            //     }
            // };

            // window.Moment = moment;

            // let duration = Moment.duration(val);

            // if (formatStr.match("hh")) {
            //     formatStr = formatStr.replace("hh", prefix(duration.get("hours")));
            //     formatStr = formatStr.replace("mm", prefix(duration.get("minutes")));
            // } else {
            //     formatStr = formatStr.replace("mm", prefix(Math.floor(duration.asMinutes())));
            // }
            // formatStr = formatStr.replace("ss", prefix(duration.get("seconds")));

            // return formatStr;
        },
        changeTime(val) {
            var that = this;
            var time = '';
            var left = '';
            var slider = '';
            if(val==0){
                that.percent = 0;
                slider = this.$refs.slider;
                slider.style.left = 0 + 'px';
                that.compose.isPlay = false;
                return;
            }
            if(val>=this.duration){
                time = 1;
                left = time*180;
            }else{
                time = val/this.duration;
                left = time*180;
            }
            this.percent = time*100;
            slider = this.$refs.slider;
            slider.style.left = left + 'px';
            that.compose.startTime = that.formatDuration(Math.ceil(val) * 1000,'hh:mm:ss');
        },
        currentTime() {
            // var audio = $('#audio')[0];
            // var currentTime = audio.currentTime;
            // this.changeTime(currentTime)
        }
    },
    destroyed: function () {

    },
    beforeDestroy() {

    },
    mounted() {
        var that = this;

        var myAudio = document.getElementById('audio');

        this.myAudio = myAudio;

        (function (doc, win) {

            var docEl = doc.documentElement,

                resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',

                recalc = function () {

                    var clientWidth = docEl.clientWidth;

                    if (!clientWidth) {

                        return;
                    }

                    var s = 100 * (clientWidth / 1920);
                    var fz = 0.4 * s + 'px';
                    var fl = 0.43 * s + 'px';
                    var fr = 0.2 * s + 'px';
                    that.compose.fz = fz;
                    that.compose.fl = fl;
                    that.compose.fr = fr;
                };

                recalc();

            if (!doc.addEventListener) {

                return;
            }
            win.addEventListener(resizeEvt, recalc, false);

            doc.addEventListener('DOMContentLoaded', recalc, false);

        })(document, window);
    },
    created() {
        
    }
}
</script>
<style scoped>
    #audio {
        position: absolute;
        top: -1000000px;
        left: 0px;
    }

    .bottom-container {
        /* position: fixed;
        bottom: 0;
        left: 0; */
        width: 100%;
        height: 74px;
        min-height: 74px;
        background: rgba(0,0,0,0.6);
    }

    .bottom-container .composeBtn-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 20px;
        box-sizing: border-box;
        /* overflow: hidden; */
    }

    .bottom-container .composeBtn-container .composeBtn {
        position: relative;
        float: left;
        margin-right: 40px;
        user-select: none;
    }

    .bottom-container .composeBtn-container .composeBtn.on {
        margin-right: 0px;
    }

    .bottom-container .composeBtn-container .composeBtn p {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #FFF;
        margin-bottom: 8px;    
    }

    .bottom-container .composeBtn-container .composeBtn p img {
        width: 14px;
        height: 14px;
        cursor: pointer;
        user-select: none;
    }

    .bottom-container .composeBtn-container .composeBtn p:hover + .tip-container {
        display: block;
    }

    .bottom-container .composeBtn-container .composeBtn .tip-container {
        display: none;
        position: absolute;
        top: -40px;
        left: -95px;
        width: 320px;
        height: 30px;
        box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.7);
        line-height: 30px;
        text-align: center;
        background: #FFF;
        font-size: 12px;
        color: #333;
        border-radius: 5px;
        box-sizing: border-box;
    }

    .bottom-container .composeBtn-container .composeBtn .tip-container::after {
        position: absolute;
        left: 50%;
        margin-left: -5px;
        content: '';
        display: block;
        width: 0; 
        height: 0;
        border-width: 6px;
        border-style: solid;
        border-color:#FFF transparent transparent transparent;
    }

    .bottom-container .composeBtn-container .composeBtn ul {
        overflow: hidden;
    }

    .bottom-container .composeBtn-container .composeBtn ul li {
        width: 34px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        margin-right: 6px;
        font-size: 12px;
        color: #FFF;
        float: left;
        border: 1px solid #FFF;
        border-radius: 4px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .bottom-container .composeBtn-container .composeBtn ul li:nth-last-of-type(1) {
        margin-right: 0px;
    }

    .bottom-container .composeBtn-container .composeBtn ul li.on {
        background: #41B48C;
        border: 1px solid #41B48C;
        box-sizing: border-box;
    }

    .bottom-container .composeBtn-container > .el-button {
        float: right;
    }

    .bottom-container .composeBtn-container > .right-btn > p {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 20px;
        font-size: 12px;
        color: #6DC7BD;
        user-select: none;
    }

    .bottom-container .composeBtn-container > .right-btn > p img {
        margin-right: 5px;
    }

    .bottom-container .composeBtn-container > .right-btn .el-button.play {
        margin-right: 20px;
        color: #fff;
        background-color: #409EFF;
        border-color: #409EFF;
        border-radius: 50%;
        padding: 12px;
    }

    .bottom-container .composeBtn-container > .right-btn .el-button {
        position: relative;
        padding: 0px;
        width: 38px;
        height: 38px;
    }

    .bottom-container .composeBtn-container > .right-btn .el-button.play span i.pause {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -7px;
        margin-left: -7px;
        display: block;
        width: 16px;
        height: 16px;
        background: url('../assets/pause.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .bottom-container .composeBtn-container > .right-btn > img {
        width: 40px;
        height: 40px;
        margin-right: 20px;
        margin-left: 43px;
        cursor: pointer;
    }

    .bottom-container .composeBtn-container > .el-button.compose {
        float: left;
        margin-top: 22px;
    }

    .bottom-container .composeBtn-container > .right-btn .el-button.compose {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 40px;
        background: rgba(65, 180, 140);
        border: 1px solid #41B48C;
        box-sizing: border-box;
        border-radius: 20px;
        font-size: 14px;
        color: #FFF;
    }

    .bottom-container .composeBtn-container > .right-btn .el-button.compose i.composeIcon {
        display: block;
        width: 16px;
        height: 15px;
        background: url('../assets/composeIcon.png') no-repeat;
        background-size: 100%;
        background-position: center;
        /* float: left; */
        /* margin: 0 4px 0 10px; */
        margin-right: 10px;
    }

    .voiceTime {
        width: 180px;
    }

    .voiceTime .el-slider {
        width: 100%;
    }

    .voiceTime span {
        font-size: 12px;
        color: #FFF;
    }

    .voiceTime span:nth-of-type(1) {
        float: left;
        user-select: none;
    }

    .voiceTime span:nth-of-type(2) {
        float: right;
        user-select: none;
    }

    .right-btn {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        /* width: 260px; */
        float: right;
    }

    .el-slider__runway {
        height: 4px !important;
    }

    .el-slider__bar {
        height: 4px !important;
        background-color: #6DC7BD !important;
    }

    .insert-container {
        /* display: none; */
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999999;
        background: rgba(0,0,0,0.5);
        /* opacity: 0; */
        animation: fadeIn 0.2s linear;
    }

    .insert-container.hide {
        display: none;
        animation: fadeOut 0.2s linear;
    }

    .insert-container .insert {
        position: absolute;
        top: 150px;
        left: 50%;
        width: 630px;
        margin-left: -315px;
        background: #FFF;
        border-radius: 5px;
        padding: 20px 30px;
        box-sizing: border-box;
    }

    .insert-container .insert .header-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        user-select: none;
    }

    .insert-container .insert .header-container p {
        line-height: 24px;
        font-size: 20px;
        color: #303133;
        margin-top: 10px;
    }

    .insert-container .insert .header-container img {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }

    .insert-container .insert .content-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin: 15px 0 30px 0;
        border-top: 1px solid rgb(215,215,215);
        padding-top: 30px;
        box-sizing: border-box;
    }

    .insert-container .insert .content-container > input {
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: 15px;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 420px;
    }

    .insert-container .insert .content-container .select {
        position: relative;
        width: 120px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        user-select: none;
    }

    .insert-container .insert .content-container .select input {
        width: 100%;
        height: 100%;
        padding: 0 30px 0 20px;
        border: none;
        box-sizing: border-box;
        outline: none;
        cursor: pointer;
    }

    .insert-container .insert .content-container .select span {
        position: absolute;
        top: 50%;
        right: 10px;
        margin-top: -6px;
        display: block;
        width: 12px;
        height: 12px;
        background: url('../assets/previewArrowIcon.png') no-repeat;
        background-position: center;
        background-size: 100%;
        cursor: pointer;
    }

    .insert-container .insert .content-container .option-container {
        position: absolute;
        top: 50px;
        left: 0px;
        z-index: 2001;
        width: 100%;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        background-color: #fff;
        list-style: none;
        padding: 6px 0;
        margin: 0;
        box-sizing: border-box;
        user-select: none;
    }

    .insert-container .insert .content-container .option-container:after {
        position: absolute;
        top: -12px;
        left: 36px;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border-width: 6px;
        border-style: solid;
        border-color: transparent transparent #ebeef5 transparent;
    }

    .insert-container .insert .content-container .option-container li {
        font-size: 14px;
        padding: 0 20px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        height: 34px;
        line-height: 34px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
    }

    .insert-container .insert .content-container .option-container li.selected {
        color: #56BCDE;
    }

    .insert-container .insert .content-container .option-container li:hover {
        background: rgb(245,247,250)
    }

    .insert-container .insert .footer-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .insert-container .insert .footer-container .el-button {
        width: 120px;
        height: 40px;
        line-height: 35px;
        padding: 0;
        font-size: 14px;
        white-space: nowrap;
        cursor: pointer;
        color: #606266;
        text-align: center;
        border-radius: 4px;
        background: #fff;
        border: 1px solid #dcdfe6;
        outline: 0;
        margin: 0;
        box-sizing: border-box;
    }

    .insert-container .insert .footer-container .el-button.confirm {
        background: #56BCDE;
        color: #FFF;
        border: 1px solid #56BCDE;
        box-sizing: border-box;
    }

    .slider-container .slider {
        position: relative;
        width: 180px;
        height: 4px;
        margin: 16px 0 10px 0;
        background-color: #e4e7ed;
        border-radius: 3px;
        user-select: none;
        cursor: pointer;
        box-sizing: border-box;
    }

    .slider-container .slider .slider-fill {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 0%;
        height: 100%;
        border-radius: 3px;
        background: #56BCDE;
        box-sizing: border-box;
    }

    .slider-container .slider .slider-pointer {
        position: absolute;
        top: 50%;
        left: 0px;
        margin-top: -8px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #56BCDE;
    }

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

</style>
